// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__1QGH5","list":"PatternAutocomplete_list__52wFf"};